// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { quickOrderStyles } from "@conklin/Overrides/Widgets/Basic/QuickOrder";
import { xScreen } from "@conklin/XDL/Utilities";
import { ButtonPresentationProps } from "@insite/mobius/Button";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

quickOrderStyles.container = {
    gap: 12,
};
quickOrderStyles.wrapper = {
    container: {
        css: css`
            border: none;
            background: ${getColor("common.ui2")};
            border-radius: 4px;
        `,
    },
};
quickOrderStyles.titleText = {
    variant: "h4",
    forwardAs: "h2",
    css: css`
        margin: 0;
    `,
};
quickOrderStyles.productSelector = {
    searchGridItem: {
        width: [12, 6, 6, 6, 6],
        css: css`
            &&& {
                flex-grow: 1;
                flex-basis: unset;
                flex-shrink: 0;
                max-width: 430px;
                position: relative;

                ${xScreen("lte", "sm")} {
                    flex-basis: 100%;
                    max-width: 100%;
                }
            }
        `,
    },
    qtyGridItem: {
        css: css`
            &&&& {
                ${xScreen("lte", "md")} {
                    padding-top: 34px;
                }
                ${xScreen("lt", "sm")} {
                    padding-top: 12px;
                }
            }
        `,
    },
};

quickOrderStyles.titleGridItem = {
    width: 12,
    css: css`
        align-items: baseline;
        gap: 24px;
    `,
};

quickOrderStyles.linksGridItem = {
    width: [2, 2, 2, 2, 2],

    css: css`
        ${xScreen("lte", "md")} {
            flex-basis: unset;
            max-width: unset;
        }
        align-items: end;
        justify-content: end;
    `,
};

quickOrderStyles.selectorItem = {
    width: [12, 12, 12, 10, 10],
    css: css`
        > div:first-child {
            width: 100%;
        }
    `,
};

const btnStyles: ButtonPresentationProps = {
    variant: "secondary",
    typographyProps: {
        size: 12,
        lineHeight: "17px",
        weight: "bold",
    },
    css: css`
        display: inline-block;
    `,
};

quickOrderStyles.orderUploadButton = {
    ...btnStyles,
};

quickOrderStyles.orderMultipleItemsLink = {
    typographyProps: {
        size: 14,
        css: css`
            line-height: 17px;
        `,
    },
};
